import styled from "styled-components/macro";

export const SinglePositionContainer = styled.div`
  width: calc(100% - 400px);
  width: ${(props) => (props.collapse ? "100% !important" : "calc(100% - 400px)")};
  transition: 0.5s ease;
  max-height: 100vh;
  overflow: hidden;
  position: relative;

  @media (max-width: 992px) {
    max-width: 100vw;
    width: 100vw;
    height: 100%;
    overflow: hidden;
    position: absolute;
    left: ${(props) => (props.viewCount ? "0" : "100%")};
    top: 0;
    transition: 0.5s ease;
  }

  @media (min-width: 1480px) {
    width: calc(100% - 480px);
  }
`;
